define('modules/form/status_view',[
  'backbone',
  'jquery',
  '_',

  './form_item_view',

  'text!./status_template.html',
  'text!modules/form/media_fact_connection/media_fact_connection_template.html'

], function (Backbone, $, _, FormItemView, template, media_fact_connection_template) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function(options) {
      _.extend(this, options);
       
      FormItemView.prototype.initialize.apply(this, options);
      var value = {};
      value[this.model.get('name')] = this.model.get('value');

      this.dataModel.set(value);

      this.render();
      this.renderMediaFactConnection();
    },
    media_fact_connection_template: _.template(media_fact_connection_template),
    template: _.template(template),
    renderMediaFactConnection: function () {
      this.$('.js-media-fact-connection').html(this.media_fact_connection_template(this.model.attributes));
      return this;
    },
    render: function() {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    }
  });
  return View;
});

